import Loading from '@baidu/hcui/lib/loading';
import Modal from '@baidu/hcui/lib/modal';
import {IdentifyResult, requestIdentifyStatus} from '@/services/common/identify.client';
import {readAgent} from '@/utils/utils';
import {MUZHI_REGISTAUTH} from '@/dicts/bridgeLink';

/**
 * 未认证——跳转端内认证页面
 */
export const identifyPage = () => {
    window.location.href = MUZHI_REGISTAUTH;
};

/**
 * 未认证——跳转端外下载页面
 */
const showDownloadAppDialog = () => {
    Modal.confirm({
        content: '您尚未认证，请下载百度健康医生端完成认证',
        animationType: 'fade',
        cancelText: '关闭',
        okText: '立即下载',
        onCancel: () => {
        },
        onOk: () => {
            window.location.href = 'https://muzhi.baidu.com/doctorapp';
        },
    });
};

/**
 * 未认证按端内、端外分发页面
 */
export const unIdentify = () => {
    const [browser] = readAgent();
    if (browser !== 'MuzhiDoctor') {
        // 端外展示下载提示框
        showDownloadAppDialog();
    } else {
        // 端内认证页
        identifyPage();
    }
};

/**
 * 校验医生是否通过认证
 * @param callback 校验通过的回调
 */
export const identify = async (callback?: () => void) => {
    let data = {} as IdentifyResult;
    try {
        Loading.show();
        data = await requestIdentifyStatus();
        if (data?.pass) {
            // 认证完成执行回调
            callback?.();
        } else {
            // 未认证
            unIdentify();
        }
        Loading.hide();
    } catch {
        Loading.hide();
    }
};
